import { Injectable } from '@angular/core';
import { PlatformInformationService } from '../../../../projects/platform-manager/src/public_api';

@Injectable({
  providedIn: 'root'
})
export class SpecialSalesService {
  constructor(private platformservice: PlatformInformationService) {}

  getActiveSale(date = new Date()):
    | {
        upToDiscount: number;
        townPageTitleTranskey?: string;
        startPageTitleTranskey?: string;
        colors?: { [key: string]: string };
      }
    | undefined {
    let config: { upToDiscount: number };

    // check end of year sales
    if (date.getMonth() > 9) {
      config = this.getConfig('blackFriday');
      if (config) {
        const thanksGiving = this.getThanksgiving(date.getFullYear()).getDate();
        if (
          date.getMonth() === 10 &&
          thanksGiving - 6 <= date.getDate() && // -3 Monday. -6 Friday.
          date.getDate() <= thanksGiving + 3 // + 1: until end of Friday. + 3 until end of Sunday
        ) {
          // Black Friday is a Day after Thanksgiving
          if (date.getDate() === thanksGiving + 1) {
            config['startPageTitleTranskey'] = 'headlineBlackFriday';
          }
          // Blac Week
          else {
            config['startPageTitleTranskey'] = 'headlineBlack';
          }

          return config;
        }
      }
      // check if cyberMonday sale is set to active
      config = this.getConfig('cyberMonday');
      if (this.getConfig('cyberMonday')) {
        const thanksGiving = this.getThanksgiving(date.getFullYear());
        thanksGiving.setDate(thanksGiving.getDate() + 4);
        if (thanksGiving.getMonth() === date.getMonth() && thanksGiving.getDate() === date.getDate()) {
          return config;
        }
      }
    }

    return undefined;
  }

  private getThanksgiving(year: number): Date {
    const novemberFirst = new Date(year, 10, 1);
    const dayOfWeek = novemberFirst.getDay(); // 0 = Sunday, 1 = Monday, ...

    // Calculate the day of the month for the first Thursday. 1.Nov So, Mo, Di Mi ? -> same week : next week
    const firstThursday = dayOfWeek <= 4 ? 4 - dayOfWeek + 1 : 12 - dayOfWeek;

    // return fourth Thursday of November (1 + 3 weeks);
    return new Date(year, 10, firstThursday + 21);
  }

  private getConfig(name: string): { upToDiscount: number } | undefined {
    if (this.platformservice.configuration?.sales) {
      return this.platformservice.configuration?.sales.find(
        s => s.name === name && s.platforms.includes(this.platformservice.getCurrentPlatformShortcode())
      );
    }
    return undefined;
  }
}
